/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';

export default (retailerPayTypes) => ({
    type: actions.CONNECTION_RETAILER_PAY_TYPES_RECEIVE,
    payload: { retailerPayTypes },
});